__turbopack_context__.v({
  "buyingContent": "iF0qja_buyingContent",
  "currentPrice": "iF0qja_currentPrice",
  "iconWrapper": "iF0qja_iconWrapper",
  "lowestPrice": "iF0qja_lowestPrice",
  "oldPrice": "iF0qja_oldPrice",
  "price": "iF0qja_price",
});
